import React, {useState} from 'react'
import { useHistory } from 'react-router'
import '../../styles/style.css'
import GLogin from '../SocialMedia/googleLogin'
import FbLogin from '../SocialMedia/fbLogin'
import RightSignIn from "../../assets/images/right-sign.svg"
import Unchacked from "../../assets/images/right-signUnCheck.svg"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import Logo from '../../assets/images/EZ_LEISURE_LOGO.svg';
import {EmailValidation, PhoneValidation} from '../../utils/Validation.js'
import CircularLoader from '../../utils/Loaders/CircularLoader';
import { Put} from '../../Api/ApiMethods.js';
import { 
  loginUrl,
 } from '../../Routes/ApiRoutes';
 import iconEmailClear from '../../assets/images/emailClear.svg';
 import iconPasswordShow from '../../assets/images/passwordShow.svg';
 import iconPasswordHide from '../../assets/images/passwordHide.svg'


export default function Login() {
    const history = useHistory()
	  const dispatch = useDispatch();
    const [data ,setData] = useState({
        "contact": '',
        "password": ''
      });
    const [passwordError, setPasswordError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [loader, setLoader] = useState(false)
    const [termCondition, setTermCondition] = useState(false);
    const [passShow, setPassShow] = useState(false);

    const onSubmit = () => {
        setLoader(true)
        if(termCondition)
        { 
          if(data.contact === '')
          {
            setEmailError('Email/Phone can not be blank')
            setLoader(false)
          }
          if(data.password === '')
          {
            setPasswordError('Password can not be blank')
            setLoader(false)
          }
          if(data.contact !== '' && data.password !== '' && !(passwordError) && !(emailError)){
            try {
              Put(loginUrl, data)
              .then(response => {
                  if(response.status === 200){
                  dispatch({
                    type: 'SIGN_IN',
                    payload: response.data.token,
                  });
                  dispatch({
                    type: 'ADMIN_DATA',
                    payload: response.data.userDetails,
                  });
                  toast.success("Logged in sucessfully.")
                  setTimeout(()=>history.push('/home'),2100)
                }
              })
              .catch(error => {
                toast.error(error.error)
                setLoader(false);
                if(error.error === "Please verify your phone")
                {
                  const verify = error.data.toVerify;
                  verify.map((item) =>{
                    setTimeout( () =>
                      history.push({ 
                      pathname: '/verifyPh',
                      state : { 'phone' : item.phone}
                      }), 2100)
                  })
                }
                else if(error.error ===  "Please verify your email")
                {
                  const verify = error.data.toVerify;
                  verify.map((item) =>{
                    item.email && setTimeout( () =>
                      history.push({ 
                      pathname: '/verifyEm',
                      state : { 'email' : item.email , message : 'only email'}
                    }), 2100);
                  })
                }
                else if(error.error.includes("Please verify your"))
                {
                  const verify = error.data.toVerify;
                  verify.map((item) =>{
                    item.email && setTimeout( () =>
                      history.push({ 
                      pathname: '/verifyEm',
                      state : { 'email' : data.contact , message : 'both'}
                    }), 2100);
                  })
                }
              })
            }catch (error) {
              toast.error(error)
              console.log(error);
              setLoader(false)
            }
          }
          else{
            setLoader(false)
          }
        }
        else{
          toast.error("Please accept terms and condition to continue.")
          setLoader(false)
        }
    }

    var handlePasswordInput = (e) => {
        let updatedDetails = { ...data };
        updatedDetails[e.target.id] = e.target.value.toString().trim();
        setData(updatedDetails)
        setPasswordError(null);
    }

    var handleEmailsInput = (e) => {
      let updatedDetails = { ...data };
      updatedDetails[e.target.id] = e.target.value.toString().trim();
      setData(updatedDetails)

      if(EmailValidation(e.target.value) || PhoneValidation(e.target.value))
      {
          setEmailError(null);
      }
      else{
        setEmailError('Invalid email/phone');
      }
    }

    const termConditionPage = (e) => {toast.success("EZ Leisure provides a safe parking location with 24 hour monitoring for your boat or RV. Our convenient app and website tools allow you to have immediate access to your vehicle. Mange your bookings, edit your vehicle and personal profile information, update your payment info, schedule onsite vehicle maintenance or report facility issues with ease.")}

    return (<>
        {loader && <CircularLoader />}
        <section className="header">
            <div className="container">
                <nav className="navbar navbar-expand-lg navbar-light bg-light login-header">
                <a className="navbar-brand">
                    <img className="img-fluid" src={Logo} />
                </a>
                </nav>
            </div>
            <ToastContainer position="top-center" autoClose={2000}/>
        </section>
        <section className="sign-in-wrapper">
            <div className="container">
                <div className="sign-in">
                <h2>SIGN IN</h2>
                <form autoComplete='off'>
                    <div className="form-group">
                      <img className='inputImage' style={{visibility : data.contact === '' ? 'hidden' : 'visible'}} 
                      alt='emailClear' src={iconEmailClear} onClick={() => {
                        let updatedDetails = { ...data };
                        updatedDetails['contact'] = '';
                        setData(updatedDetails)
                        setEmailError(null);
                      }} />
                      <input className={emailError ? "form-control borderRed" : "form-control" }
                      onChange={(e) => handleEmailsInput(e)} value={data.contact}
                      id='contact' type="text" placeholder="Email/Phone" />
                      {emailError && <span className='form-error'>{emailError}</span>}
                    </div>
                    <div className="form-group">
                    <img className='inputImage' style={{visibility : data.password === '' ? 'hidden' : 'visible'}} 
                      alt='emailClear' src={ passShow ? iconPasswordHide : iconPasswordShow} onClick={() => {
                        let pass = document.getElementById('password');
                        if(pass.type === 'text'){
                          pass.type = 'password';
                        }else{
                          pass.type = 'text';
                        }
                        setPassShow(!passShow);
                      }} />
                      <input className={passwordError ? "form-control borderRed" : "form-control" }
                      onChange={(e) => handlePasswordInput(e)} value={data.password}
                      id='password' type="password" placeholder="Password" />
                      {passwordError && <span className='form-error'>{passwordError}</span>}
                    </div>
                    <div className="Forgot">
                        <a className='link' onClick={() => history.push(`/forgetPassword`)}>Forgot Password?</a>
                    </div>
                    <div className="Terms-Conditions">
                        <h5><img className='link' onClick={() => setTermCondition(!termCondition)} src={termCondition ? RightSignIn : Unchacked} />
                      I accept the 
                      <a className='link' onClick = {(e)=> {termConditionPage(e)}}>Terms & Conditions</a>
                      </h5>
                    </div>
                    <div className="comman-btn">
                        <button onClick={onSubmit} type='button'>Sign in</button>
                    </div>
                </form>
                <div className="sign-in-with">
                    <p>Sign in with  <GLogin termCondition={termCondition} /></p>
                    <p><FbLogin termCondition={termCondition} /></p>

                    <div className="Not-member">
                      <p>Not a member? <a className='link' onClick={() => history.push(`/signUp`)}>Sign up</a></p>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </>)
}
